export enum AppConstants_settings {
  BACKOFFICE_URL = 'http://api.traveltechminds.com/backofficeapi/api/Backoffice',
  B2CAPI_URL = 'http://api.traveltechminds.com/backofficeapi/api/B2C/',
  COMMON_URL = 'http://api.traveltechminds.com/backofficeapi/api/CommonAPI/',
  CHANNEL = '',
  COMPANY_ID = '',
  ActiveBOC_ID = '',
  BRANCH_ID = '',
  ACTIVE_CHANNAL = ''
}
